// extracted by mini-css-extract-plugin
export default {"title":"Slab_title__8jftA","navigation":"Slab_navigation__uU2iE","content":"Slab_content__Sx04W"};